export type StreamingTextProps = {
  content: string;
  className?: string;
};

/**
 * 流式阶段的稳定纯文本视图。
 * 未完成内容不进入 Markdown 解析器，避免未闭合语法反复改变 DOM 结构。
 */
export function StreamingText({ className, content }: StreamingTextProps) {
  return (
    <div
      className={["herskin-markdown", "herskin-markdown--streaming", className]
        .filter(Boolean)
        .join(" ")}
    >
      {content}
    </div>
  );
}
